(() => {
  'use strict';
  if (window.__zestyCollab) return;
  window.__zestyCollab = true;
  const controllers = new Map();
  function init(root) {
    if (controllers.has(root)) return;
    const abort = new AbortController();
    const on = (element, event, callback) => element?.addEventListener(event, callback, {signal: abort.signal});
    root.querySelectorAll('[data-zesty-return]').forEach(link => on(link, 'click', event => {
      const email = root.querySelector('.zesty-signup input[type="email"]');
      const action = root.querySelector('.zesty-info');
      if (!email || !action) return;
      event.preventDefault();
      action.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      email.focus({preventScroll: true});
    }));
    root.querySelectorAll('[data-zesty-gallery]').forEach(button => on(button,'click', () => {
      const index = button.dataset.zestyGallery;
      root.querySelectorAll('[data-zesty-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.zestyGalleryPanel !== index; if (!panel.hidden) panel.querySelectorAll('img').forEach(img => {img.loading='eager';}); });
      root.querySelectorAll('[data-zesty-gallery]').forEach(item => item.setAttribute('aria-pressed',String(item===button)));
    }));
    const form = root.querySelector('.zesty-purchase');
    if (form) {
      const variant = form.querySelector('[data-zesty-variant]');
      const button = form.querySelector('[data-zesty-add]');
      const quantity = form.querySelector('[name="quantity"]');
      const status = form.querySelector('[data-zesty-cart-status]');
      const cartLink = form.querySelector('[data-zesty-view-cart]');
      let pending = false;
      let uncertain = false;
      const update = () => {
        const option = variant.selectedOptions[0];
        button.disabled = pending || uncertain || option?.dataset.available !== 'true';
        button.textContent = pending ? 'Adding…' : uncertain ? 'Check your cart' : option?.dataset.available === 'true' ? 'Add bundle to cart' : 'Sold out';
        root.querySelector('[data-zesty-price]').textContent = option?.dataset.price || '';
      };
      on(variant, 'change', () => {
        if (uncertain) return;
        update();
        const url = new URL(location.href);
        url.searchParams.set('variant',variant.value);
        history.replaceState(null,'',url);
      });
      on(form, 'submit', async event => {
        if (!window.BCJCartEntrypoints?.add || !window.FormData) return;
        event.preventDefault();
        if (pending || uncertain || button.disabled || !form.reportValidity()) return;
        const payload = new FormData(form);
        pending = true; variant.disabled = true; quantity.disabled = true; update();
        status.textContent = 'Adding your bundle…';
        try {
          await window.BCJCartEntrypoints.add(payload, {source:'zesty-halloween'});
          status.textContent = 'Added to your cart.';
          cartLink.hidden = false;
        } catch(error) {
          uncertain = Boolean(error.uncertain);
          status.textContent = uncertain ? 'We couldn’t confirm the add. Check your cart before trying again so you don’t add the bundle twice.' : (error.message || 'Could not add the bundle. Please try again.');
          cartLink.hidden = !uncertain;
          status.focus();
        } finally {
          pending = false; variant.disabled = uncertain; quantity.disabled = uncertain; update();
        }
      });
    }
    controllers.set(root, () => { abort.abort(); controllers.delete(root); });
  }
  function scan(scope = document) {scope.querySelectorAll('[data-zesty-collab]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true}); else scan();
  document.addEventListener('shopify:section:load',event => scan(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-zesty-collab]').forEach(root => controllers.get(root)?.()));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-zesty-banner-link]');
    if (link && navigator.globalPrivacyControl !== true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
      const detail = {campaign:'zesty_halloween_2026',state:link.dataset.state,placement:'homepage'};
      document.dispatchEvent(new CustomEvent('zesty:banner',{detail}));
      try { Promise.resolve(window.Shopify.analytics?.publish?.('bcj_zesty_banner_click',detail)).catch(() => {}); } catch (_) { /* Tracking never blocks navigation. */ }
    }
  });
})();
